export default {
  name: 'fullsize',
  type: 'layout',
  active: false,
  data: {
    align: 'center'
  }
}
